import moment from 'moment'
moment.locale("zh-CN")

const filterOption = (value, options) => options.filter(op => op.value == value)[0]

const tableHelper = {

  tag(value, options, defaultType = '') {
    return (filterOption(value, options) || { type: defaultType }).type
  },

  label(value, options, defaultLabel = '') {
    defaultLabel = defaultLabel || value
    return (filterOption(value, options) || { label: defaultLabel }).label
  },

  fmts: {

    price(_, __, value) {
      let formatValue = value * 1
      if (isNaN(formatValue)) {
        formatValue = 0
      }
      formatValue = formatValue.toFixed(2)
      return `￥${formatValue}`
    },

    date(_, __, value) {
      return moment(value).calendar()
    }

  }

}

export default {

  install(Vue) {
    Vue.prototype.$tableHelper = tableHelper
  }

}
